const CitizenHistoryActions = {
    editables: ['COMMENT', 'INTERVIEW', 'REFERRED', 'CALL', 'PATROL', 'VISIT', 'INACTIVATION', 'INACTIVATION_REVOCATION', 'INACTIVATION_REFUSAL', 'INACTIVATION_TERMINATION', 'ATTENDANCE', 'GUIDANCE'],

    options: [
        {value: "NEW_WEB", label: 'Cadastro pela web'},
        {value: "NEW_MOBILE", label: 'Cadastro pelo app'},
        {value: "ACTIVATION", label: 'Ativação'},
        {value: "INACTIVATION", label: 'Inativação - Outros'},
        {value: "INACTIVATION_REFUSAL", label: 'Inativação - Recusa'},
        {value: "INACTIVATION_REVOCATION", label: 'Inativação - Revogação'},
        {value: "INACTIVATION_TERMINATION", label: 'Inativação - Desligamento'},
        {value: "INTERVIEW", label: 'Entrevista'},
        {value: "PATROL", label: 'Ronda'},
        {value: "CALL", label: 'Ligação'},
        {value: "VISIT", label: 'Visita'},
        {value: "REFERRED", label: 'Encaminhamento'},
        {value: "COMMENT", label: 'Comentário'},
        {value: "EVENT_START", label: 'SOS - aberto'},
        {value: "EVENT_TARGET_ADDRESS", label: 'SOS - endereço selecionado'},
        {value: "EVENT_TARGET_CITIZEN", label: 'SOS - cidadão selecionado'},
        {value: "EVENT_ACK", label: 'SOS - assumido'},
        {value: "EVENT_END", label: 'SOS - finalizado'},
        {value: "PASSWORD_CHANGE", label: 'Mudança de senha'},
        {value: "PASSWORD_RECOVERY", label: 'Recuperação de senha'},
        {value: "ATTENDANCE", label: 'Atendimento'},
        {value: "GUIDANCE", label: 'Orientação'}
    ],

    editableOptions: () => {
        return CitizenHistoryActions.options
            .filter((option) => ['COMMENT', 'INTERVIEW', 'REFERRED', 'CALL', 'PATROL', 'VISIT', 'ATTENDANCE', 'GUIDANCE'].includes(option.value))
            .sort((a,b) => a.label.localeCompare(b.label));
    },

    toView: (action) => {
        if (!action) return "";

        return CitizenHistoryActions.options.find(({value}) => action === value)?.label ?? "";
    },

    toOption: (action) => {
        if (!action) return "";

        return CitizenHistoryActions.options.find(({value}) => action === value);
    }
};

export default CitizenHistoryActions;